var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "club-points-detail" },
    [
      _c(
        "div",
        { staticClass: "club-points-detail__head" },
        [
          _c("div", { staticClass: "club-points-detail__head-title" }, [
            _vm._v("\n      " + _vm._s(_vm.title) + "\n    ")
          ]),
          _c("info-block", { attrs: { "tooltip-text": _vm.tooltip } })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "club-points-detail__content" },
        [
          _c("f-sprite-icon", {
            staticClass: "club-points-detail__icon",
            attrs: { "icon-link": _vm.iconLink }
          }),
          _c("div", { class: _vm.classes }, [
            _vm._v("\n      " + _vm._s(_vm._f("price")(_vm.points)) + "\n    ")
          ])
        ],
        1
      ),
      _vm.pointsBurnsInt > 0
        ? _c("club-summary-burns", {
            attrs: { points: _vm.pointsBurnsInt, date: _vm.date }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }